if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.pickupLocationChangeHandler = () => this.refreshPickupAvailability();
        this.packModeChangeHandler = (event) => {
          if (event.detail?.formId === this.form?.id) this.refreshPickupAvailability();
        };
        this.pickupVariantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        window.duplinPickupGuard?.observe(this, () => this.refreshPickupAvailability());
        document.addEventListener('duplin:pickup-location-changed', this.pickupLocationChangeHandler);
        document.addEventListener('duplin:pack-mode-changed', this.packModeChangeHandler);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.pickupVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const productInfo = this.closest('product-info');
            if (!productInfo || event?.data?.sectionId !== productInfo.dataset.section) return;
            this.refreshPickupAvailability();
          });
        }
      }

      disconnectedCallback() {
        window.duplinPickupGuard?.unobserve(this);
        document.removeEventListener('duplin:pickup-location-changed', this.pickupLocationChangeHandler);
        document.removeEventListener('duplin:pack-mode-changed', this.packModeChangeHandler);
        this.pickupVariantChangeUnsubscriber?.();
      }

      applyPickupAvailability(result) {
        window.duplinPickupGuard?.renderMessage(this, result);
        const pickupUnavailable = result?.shouldCheck && !result.available;
        if (pickupUnavailable) {
          this.submitButton.dataset.pickupUnavailable = 'true';
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else if (this.submitButton.dataset.pickupUnavailable === 'true') {
          delete this.submitButton.dataset.pickupUnavailable;
          if (!this.variantIdInput.disabled) this.submitButton.removeAttribute('aria-disabled');
        }
      }

      getRequestedQuantity() {
        const packQuantity = this.form.querySelector('[data-pack-actual-quantity]');
        if (packQuantity) return Number.parseInt(packQuantity.value || '1', 10) || 1;

        const formId = this.form?.id;
        const escapedFormId = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(formId || '') : formId;
        const externalQuantity = formId
          ? document.querySelector(`[form="${escapedFormId}"][name="quantity"]`)
          : null;
        return Number.parseInt(externalQuantity?.value || this.form.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
      }

      async refreshPickupAvailability(forceCartRefresh = false) {
        if (!window.duplinPickupGuard) return true;
        const variantId = this.variantIdInput?.value;
        if (!variantId) return true;

        try {
          const quantity = this.getRequestedQuantity();
          const result = await window.duplinPickupGuard.check({
            element: this,
            variantId,
            requestedAddition: quantity,
            forceCartRefresh,
          });
          this.applyPickupAvailability(result);
          return result.available;
        } catch (error) {
          console.error('Unable to validate pickup inventory before add:', error);
          this.applyPickupAvailability(window.duplinPickupGuard.getValidationErrorResult());
          return false;
        }
      }
      updateLowStockIndicator(locationQuantity) {
        const inventoryDiv = document.querySelector('.product__info-container .product__inventory');
        if (!inventoryDiv) return;
        // const selectedInput = document.querySelector('input[name^="Select Pack Size"]:checked');
        // const selectedValue = selectedInput?.value?.trim();
      
        // {% if product_inventory_threshold != blank %}
        //   const threshold = {{ product_inventory_threshold }};
        // {% else %}
        //   const threshold = parseInt(inventoryDiv.dataset.productThreshold);
        // {% endif %};
        const threshold = 10
        const showQty = inventoryDiv.dataset.show_inventory_quantity === 'true';
        
          // const isCase = selectedValue === 'Case';
          // const displayQty = isCase ? Math.floor(locationQuantity / 12) : locationQuantity;
      
        // Only show indicator if locationQuantity > 0 and <= threshold, and threshold is a valid number
        if (!isNaN(threshold) && locationQuantity > 0 && locationQuantity <= threshold) {
          const iconSvg = `
            <span class="svg-wrapper" style="color: rgb(238, 148, 65)">
              {{- 'icon-inventory-status.svg' | inline_asset_content -}}
            </span>
          `;
          
          const message = showQty
            ? `Hurry Up! Only ${locationQuantity} in Stock`
            : `{{- 'products.product.inventory_low_stock' | t -}}`;
          inventoryDiv.classList.remove('hidden');
          inventoryDiv.innerHTML = `${iconSvg} ${message}`;
        } else {
          inventoryDiv.innerHTML = '';
        }
    }

      getMainEventContext(formData) {
        const productInfo = this.closest('product-info') || document.querySelector('product-info.info_main_item');
        const selectedVariantElement = productInfo?.querySelector('variant-selects [data-selected-variant]');
        let selectedVariant = null;
        if (selectedVariantElement?.textContent) {
          try {
            selectedVariant = JSON.parse(selectedVariantElement.textContent.trim());
          } catch (_) {}
        }

        const submittedVariantId = String(formData.get('id') || '');
        if (selectedVariant && submittedVariantId && String(selectedVariant.id) !== submittedVariantId) {
          selectedVariant = null;
        }

        const name = String(
          productInfo?.dataset.productName ||
          document.querySelector('.product__title h1')?.textContent ||
          document.querySelector('h1')?.textContent ||
          ''
        ).trim();
        const details = String(selectedVariant?.public_title || selectedVariant?.title || '').trim();
        if (!name || !details) return null;

        return {
          name,
          details,
          key: `${name} - ${details}`,
          variantId: submittedVariantId,
          price: typeof selectedVariant?.price === 'number' ? selectedVariant.price : null,
        };
      }

      applyEventAssociationToFormData(formData, productType) {
        if (this.dataset.addOnProductId) {
          const modal = this.closest('#event-add-ons-modal');
          if (!modal?.classList.contains('is-open')) return null;

          const name = String(modal.dataset.mainEventName || '').trim();
          const details = String(modal.dataset.mainEventDetails || '').trim();
          const key = String(modal.dataset.mainEventKey || '').trim();
          if (!name || !details || !key) return null;

          formData.set('properties[Main Event Name]', name);
          formData.set('properties[Main Event details]', details);
          formData.set('properties[_main_event_key]', key);
          return { name, details, key };
        }

        if (productType !== 'Ticket' || !formData.has('properties[main-event-key]')) return null;
        const context = this.getMainEventContext(formData);
        if (!context) return null;
        formData.set('properties[main-event-key]', context.key);
        return context;
      }
      
      async onSubmitHandler(evt) {
        evt.preventDefault();

        window.DuplinPack?.sync(this);
        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const eventSoldOutIds = (this.dataset.eventSoldOutVariantIds || '').split(',');
        if (this.dataset.productType === 'Ticket' && eventSoldOutIds.includes(String(variantId))) {
          this.toggleSubmitButton(true, window.variantStrings.soldOut);
          this.handleErrorMessage(window.variantStrings.soldOut);
          return;
        }
        const clubOnlyIds = this.dataset.clubMembersOnlyVariantIds || '';
        const customerCanAddClubVariant = this.dataset.customerCanAddClubVariant === 'true';
        if (clubOnlyIds && variantId) {
          const clubOnlyIdList = clubOnlyIds.split(',').map((id) => id.trim()).filter(Boolean);
          if (clubOnlyIdList.includes(String(variantId)) && !customerCanAddClubVariant) {
            this.handleErrorMessage('This option is for club members only. Please log in or join the club to purchase.');
            return;
          }
        }

        this.handleErrorMessage();
        if (this.dataset.addOnProductId) {
          this.setEventAddOnsModalError('');
        }

        const infoMainItem = document.querySelector('.info_main_item');
        const productType = infoMainItem?.getAttribute('data-product-type');
        const submittedMainEventContext = this.applyEventAssociationToFormData(formData, productType);

        if (this.dataset.addOnProductId && this.dataset.eventVariantMatched === 'false') {
          this.setEventAddOnsModalError('This add-on is not available for the selected event date.');
          return;
        }

        // Contact details belong to the main ticket. Add-ons keep their event
        // association and must not revalidate the blank ticket form after a revisit.
        if (productType === 'Ticket' && !this.dataset.addOnProductId) {
          const firstNameField = document.querySelector('input[name="properties[First Name]"]');
          const lastNameField = document.querySelector('input[name="properties[Last Name]"]');
          const nameField = document.querySelector('input[name="properties[Name]"]');
          const emailField = document.querySelector('input[name="properties[Email]"]');
          const mobileField = document.querySelector('input[name="properties[Mobile Number]"]');
          // const ticketTypeField = document.querySelector('select[name="properties[Ticket Type]"]');
          // const personCountField = document.querySelector('input[name="properties[Number Of People]"]');

          let errors = [];

          const firstNameValue = firstNameField?.value.trim() || '';
          const lastNameValue = lastNameField?.value.trim() || '';
          const mobileValue = mobileField?.value.trim() || '';

          if (!firstNameField || firstNameValue === '') {
            errors.push('First name is required');
            firstNameField?.classList.add('field-error');
          } else {
            firstNameField.classList.remove('field-error');
          }

          if (!lastNameField || lastNameValue === '') {
            errors.push('Last name is required');
            lastNameField?.classList.add('field-error');
          } else {
            lastNameField.classList.remove('field-error');
          }

          if (!mobileField || mobileValue === '') {
            errors.push('Mobile number is required');
            mobileField?.classList.add('field-error');
          } else {
            mobileField.classList.remove('field-error');
          }

          // Merge first + last name into single Name property so it is sent
          // as `properties[Name]` to the cart line item.
          const fullName = `${firstNameValue} ${lastNameValue}`.trim();
          if (fullName) {
            formData.set('properties[Name]', fullName);
            if (nameField) {
              nameField.value = fullName;
            } else {
              const hiddenNameField = document.createElement('input');
              hiddenNameField.type = 'hidden';
              hiddenNameField.name = 'properties[Name]';
              hiddenNameField.value = fullName;
              this.form.appendChild(hiddenNameField);
            }
          }

          if (!emailField || emailField.value.trim() === '') {
            errors.push('Email is required');
            emailField.classList.add('field-error');
          } else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailField.value.trim())) {
            errors.push('Invalid email address');
            emailField.classList.add('field-error');
          } else {
            emailField.classList.remove('field-error');
          }

          // if (!ticketTypeField || ticketTypeField.value.trim() === '') {
          //   errors.push('Ticket type is required');
          //   ticketTypeField.classList.add('field-error');
          // } else {
          //   ticketTypeField.classList.remove('field-error');
          // }

          // if (ticketTypeField?.value === 'Table') {
          //   if (!personCountField || personCountField.value.trim() === '') {
          //     errors.push('Number of people is required for Table tickets');
          //     personCountField.classList.add('field-error');
          //   } else {
          //     personCountField.classList.remove('field-error');
          //   }
          // }

          if (errors.length > 0) {
            if (this.dataset.addOnProductId) {
              this.setEventAddOnsModalError(errors.join('. '));
            }
            this.handleErrorMessage(errors.join('. '));
            // [nameField, emailField, ticketTypeField, personCountField].forEach((field) => {
            [firstNameField, lastNameField, emailField, mobileField].forEach((field) => {
              if (!field) return;
              field.addEventListener('input', () => {
                const value = field.value.trim();
                if (value) {
                  field.classList.remove('field-error');
                  // If no more red fields, hide error message box
                  const anyErrorLeft = this.form.querySelectorAll('.field-error').length > 0;
                  if (!anyErrorLeft) this.handleErrorMessage('');
                }
              });
            });
            return; // stop submit
          }
        }

        if (!(await this.refreshPickupAvailability(true))) return;
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        if (this.dataset.addOnProductId) {
          this.setEventAddOnsModalError('');
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //console.log('sss=-',this.querySelector('.loading__spinner'))
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            window.duplinPickupGuard?.invalidateCart();
            window.DuplinPack?.recordCartAddition(this, formData.get('quantity'));
            const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
            if (cartItems?.syncSubscriptionSlabsForVariant) {
              const synced = await cartItems.syncSubscriptionSlabsForVariant(formData.get('id'), response);
              if (synced) response = synced;
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }

            if (this.dataset.addOnProductId) {
              this.setEventAddOnsModalError('');
              this.submitButton.classList.add('is-added');
              const addLabel = this.submitButton.querySelector('span:first-child');
              if (addLabel) addLabel.textContent = 'Added';

              const modal = document.getElementById('event-add-ons-modal');
              if (modal && modal.classList.contains('is-open')) {
                setTimeout(() => this.refreshEventAddOnsModalSummary(modal), 250);
              }
              document.dispatchEvent(
                new CustomEvent('event-add-ons:added', {
                  detail: {
                    addOnProductId: this.dataset.addOnProductId,
                  },
                })
              );
            }

            // For Ticket products, show event add-ons in a popup after main event is added to cart.
            // (Skip when the submitted form is itself an add-on product-form.)
            if (productType === 'Ticket' && !this.dataset.addOnProductId) {
              try {
                const addOnsJsonEl =
                  document.querySelector('product-info variant-selects [data-product-add-ons]') ||
                  document.querySelector('variant-selects [data-product-add-ons]');

                const addOnsWrapper =
                  document.querySelector('.al-pdp-event-add-on-wrapper') ||
                  document.querySelector('[id^="event-add-on-"].al-pdp-event-add-on-wrapper');

                const hasAddOns =
                  addOnsJsonEl && (() => {
                    const parsed = JSON.parse(addOnsJsonEl.textContent.trim());
                    return Array.isArray(parsed?.event_add_ons) && parsed.event_add_ons.length > 0;
                  })();

                if (hasAddOns && addOnsWrapper) {
                  const responseProperties = response?.properties || {};
                  const responseName = String(response?.product_title || submittedMainEventContext?.name || '').trim();
                  const responseDetails = String(response?.variant_title || submittedMainEventContext?.details || '').trim();
                  const responseKey = String(
                    responseProperties['main-event-key'] ||
                    submittedMainEventContext?.key ||
                    (responseName && responseDetails ? `${responseName} - ${responseDetails}` : '')
                  ).trim();
                  this.showEventAddOnsModal(addOnsWrapper, {
                    name: responseName,
                    details: responseDetails,
                    key: responseKey,
                    price: submittedMainEventContext?.price,
                  });
                }
              } catch (e) {
                // If parsing fails or DOM isn't present, silently skip popup.
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
            setTimeout(()=>{
              if (window.DuplinPack?.refreshAfterCartAdd(this)) return;
              const quantityInputs = document.querySelectorAll('.price-per-item__container input.quantity__input');
              const productForm = document.querySelector('.product__info-container product-form.product-form form');
              const addToCartButton = productForm?.querySelector('.product-form__buttons button');
                quantityInputs.forEach(input => {
                  const availQty = parseInt(input.getAttribute('avail-qty'))
                  const cartQty = parseInt(input.getAttribute('data-cart-quantity'))
                  const adjustedMax = Math.max(0,availQty - cartQty);
                  input.setAttribute('max', adjustedMax);
                  // Adjust input value if needed
                  let current = parseInt(input.value) || 1;
                  if (current > adjustedMax) current = adjustedMax;
                  input.value = current;
                  if (addToCartButton) {
                      if (adjustedMax === 0) {
                        // addToCartButton.innerText = "Sold out"
                        addToCartButton.setAttribute('disabled', 'disabled');
                      } else {
                        // addToCartButton.innerText = "Add to cart"
                        addToCartButton.removeAttribute('disabled');
                      }
                  }
                  input.dispatchEvent(new Event('input', { bubbles: true }));
                  input.dispatchEvent(new Event('change', { bubbles: true }));
  
                  const inventoryDiv = document.querySelector('.product__info-container .product__inventory');
                  if (!inventoryDiv) return;
                    const threshold = parseInt(inventoryDiv.dataset.productThreshold);
                    const showQty = inventoryDiv.dataset.show_inventory_quantity === 'true';
                  if (!isNaN(threshold) && adjustedMax > 0 && adjustedMax <= threshold) {
                    const iconSvg = `
                      <span class="svg-wrapper" style="color: rgb(238, 148, 65)"><svg class="icon icon-inventory-status" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <ellipse cx="7.09011" cy="7.06177" rx="7.09011" ry="7" fill="#50C1BC"></ellipse>
                      </svg></span>
                    `;
                    
                    const message = showQty
                      ? `Hurry Up! Only ${adjustedMax} in Stock`
                      : `{{- 'products.product.inventory_low_stock' | t -}}`;
                    inventoryDiv.classList.remove('hidden');
                    inventoryDiv.innerHTML = `${iconSvg} ${message}`;
                  } else {
                    inventoryDiv.innerHTML = '';
                  }
                });
            },1000);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      setEventAddOnsModalError(errorMessage = '') {
        const modal = document.getElementById('event-add-ons-modal');
        const modalErrors = modal?.querySelectorAll('[data-addon-form-error]');
        if (!modalErrors || !modalErrors.length) return;
        modalErrors.forEach((errorEl) => {
          errorEl.textContent = errorMessage || '';
          errorEl.hidden = !errorMessage;
        });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      formatEventAddOnMoney(cents, currencyCode) {
        const amount = Number(cents) / 100;
        if (!Number.isFinite(amount)) return '';
        const hasDecimal = Math.round(amount * 100) % 100 !== 0;
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode || window.Shopify?.currency?.active || window.Shopify?.currency?.shop || 'USD',
          minimumFractionDigits: hasDecimal ? 2 : 0,
          maximumFractionDigits: 2,
        }).format(amount);
      }

      getEventAddOnVariantConfig(form) {
        const productForm = form.closest('product-form[data-add-on-product-id]');
        const addOnProductId = productForm?.dataset?.addOnProductId;
        if (!addOnProductId) return null;

        const variantScript = document.querySelector(
          `script[data-all-addon-variants][data-add-on-product-id="${addOnProductId}"]`
        );
        if (!variantScript) return null;

        let variants = [];
        try {
          variants = JSON.parse(variantScript.textContent || '[]');
        } catch (_) {
          return null;
        }
        if (!Array.isArray(variants) || variants.length === 0) return null;

        const idInput = form.querySelector('input[name="id"]');
        const currentVariantId = String(idInput?.value || '');
        return variants.find((variant) => String(variant.id) === currentVariantId) || variants[0] || null;
      }

      applyEventAddOnQuantityRules(form) {
        const qtyInput = form.querySelector('.event-add-ons-modal__actions .quantity__input');
        const qtyRoot = qtyInput?.closest('quantity-input');
        if (!qtyInput || !qtyRoot) return;

        const variant = this.getEventAddOnVariantConfig(form);
        const min = Number.parseInt(variant?.quantity_rule?.min, 10) || 1;
        const step = Number.parseInt(variant?.quantity_rule?.increment, 10) || 1;
        const rawMaxFromRule = variant?.quantity_rule?.max;
        const maxFromRule = rawMaxFromRule == null ? null : Number.parseInt(rawMaxFromRule, 10);

        let max = Number.isFinite(maxFromRule) ? maxFromRule : null;
        const inventoryQty = Number.parseInt(variant?.inventory_quantity, 10);
        const inventoryManaged = variant?.inventory_management != null;
        const continueSelling = variant?.inventory_policy === 'continue';
        if (max == null && inventoryManaged && !continueSelling && Number.isFinite(inventoryQty) && inventoryQty >= 0) {
          max = inventoryQty;
        }

        qtyInput.setAttribute('min', String(min));
        qtyInput.setAttribute('data-min', String(min));
        qtyInput.setAttribute('step', String(step));
        if (Number.isFinite(max) && max > 0) {
          qtyInput.setAttribute('max', String(max));
        } else {
          qtyInput.removeAttribute('max');
        }

        let normalizedValue = Number.parseInt(qtyInput.value, 10);
        if (!Number.isFinite(normalizedValue)) normalizedValue = min;
        if (normalizedValue < min) normalizedValue = min;
        if (Number.isFinite(max) && max > 0 && normalizedValue > max) normalizedValue = max;
        qtyInput.value = String(normalizedValue);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      refreshEventAddOnsModalSummary(modal) {
        const summaryTextEl = modal?.querySelector('[data-addon-summary]');
        if (!summaryTextEl) return;

        const mainEventName = (modal.dataset.mainEventName || '').trim();
        const mainEventDetails = (modal.dataset.mainEventDetails || '').trim();
        if (!mainEventName) {
          summaryTextEl.textContent = 'No add-ons selected yet';
          return;
        }

        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            const items = Array.isArray(cart?.items) ? cart.items : [];
            const relatedAddOns = items.filter((item) => {
              const props = item?.properties || {};
              const lineMainEventName = String(props['Main Event Name'] || '').trim();
              if (lineMainEventName !== mainEventName) return false;

              const lineMainEventDetails = String(props['Main Event details'] || '').trim();
              if (!mainEventDetails || !lineMainEventDetails) return true;
              return lineMainEventDetails === mainEventDetails;
            });

            if (!relatedAddOns.length) {
              summaryTextEl.textContent = 'No add-ons selected yet';
              return;
            }

            const summary = relatedAddOns
              .map((item) => {
                const quantity = Number(item.quantity) || 1;
                const itemTitle = item.product_title || item.title || 'Add-on';
                const itemPrice = this.formatEventAddOnMoney(item.final_price, cart?.currency);
                return `${quantity} x ${itemTitle} (${itemPrice})`;
              })
              .join(', ');

            summaryTextEl.textContent = summary;
          })
          .catch(() => {
            summaryTextEl.textContent = 'No add-ons selected yet';
          });
      }

      initializeEventAddOnModalControls(addOnsWrapper) {
        const forms = addOnsWrapper.querySelectorAll('product-form[data-add-on-product-id] form');
        forms.forEach((form) => {
          const submitBtn = form.querySelector('.event-add-on-submit-btn, button[data-event-add-on-submit]');
          if (!submitBtn) return;

          if (form.dataset.modalControlsReady !== 'true') {
            const actionsRow = document.createElement('div');
            actionsRow.className = 'event-add-ons-modal__actions';

            const quantityWrap = document.createElement('div');
            quantityWrap.className = 'event-add-ons-modal__qty-wrap';
            quantityWrap.innerHTML = `
              <quantity-input class="quantity event-add-ons-modal__quantity">
                <button class="quantity__button" name="minus" type="button">
                  <span class="svg-wrapper" aria-hidden="true">−</span>
                </button>
                <input
                  class="quantity__input"
                  type="number"
                  name="quantity"
                  value="1"
                  min="1"
                  data-min="1"
                  step="1"
                  inputmode="numeric"
                  aria-label="Quantity"
                >
                <button class="quantity__button" name="plus" type="button">
                  <span class="svg-wrapper" aria-hidden="true">+</span>
                </button>
              </quantity-input>
            `;

            submitBtn.parentNode.insertBefore(actionsRow, submitBtn);
            actionsRow.appendChild(quantityWrap);
            actionsRow.appendChild(submitBtn);
            const inlineError = document.createElement('p');
            inlineError.className = 'event-add-ons-modal__inline-error';
            inlineError.setAttribute('data-addon-form-error', '');
            inlineError.hidden = true;
            actionsRow.appendChild(inlineError);

            const qtyInput = quantityWrap.querySelector('.quantity__input');
            const normalizeQty = () => {
              let value = Number.parseInt(qtyInput.value, 10);
              if (!Number.isFinite(value) || value < 1) value = 1;
              qtyInput.value = String(value);
            };
            qtyInput?.addEventListener('input', normalizeQty);
            qtyInput?.addEventListener('blur', normalizeQty);
            qtyInput?.addEventListener('change', () => {
              if (submitBtn.disabled) return;
              submitBtn.classList.remove('is-added');
              const labelSpan = submitBtn.querySelector('span:first-child');
              if (labelSpan) labelSpan.textContent = 'Add';
            });

            const idInput = form.querySelector('input[name="id"]');
            idInput?.addEventListener('change', () => this.applyEventAddOnQuantityRules(form));
            form.dataset.modalControlsReady = 'true';
          }

          this.applyEventAddOnQuantityRules(form);

          if (!submitBtn.disabled) {
            submitBtn.classList.remove('is-added');
            const labelSpan = submitBtn.querySelector('span:first-child');
            if (labelSpan) labelSpan.textContent = 'Add';
          }
        });
      }

      resetEventAddOnModalQuantities(addOnsWrapper) {
        const forms = addOnsWrapper.querySelectorAll('product-form[data-add-on-product-id] form');
        forms.forEach((form) => {
          const qtyInput = form.querySelector('.event-add-ons-modal__actions .quantity__input');
          if (!qtyInput) return;
          qtyInput.value = '1';
          this.applyEventAddOnQuantityRules(form);
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      showEventAddOnsModal(addOnsWrapper, mainEventContext = null) {
        const existing = document.getElementById('event-add-ons-modal');
        let modal = existing;
        if (!modal) {
          modal = document.createElement('div');
          modal.id = 'event-add-ons-modal';
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');
          modal.setAttribute('aria-hidden', 'true');
          modal.className = 'event-add-ons-modal';

          modal.innerHTML = `
            <div class="event-add-ons-modal__dialog">
              <button type="button" data-close class="event-add-ons-modal__close" aria-label="Close">×</button>
              <div class="event-add-ons-modal__header">
                <p class="event-add-ons-modal__status">Added to cart</p>
                <h3 class="event-add-ons-modal__title" data-main-title></h3>
                <p class="event-add-ons-modal__meta" data-main-meta></p>
                <p class="event-add-ons-modal__subtitle">Enhance your experience</p>
              </div>
              <div class="event-add-ons-modal__body" data-body></div>
              <div class="event-add-ons-modal__footer">
                <p class="event-add-ons-modal__summary">
                  <span class="event-add-ons-modal__summary-label">Add-ons:</span>
                  <span data-addon-summary>No add-ons selected yet</span>
                </p>
                <button type="button" class="event-add-ons-modal__proceed button button--primary" data-proceed-to-cart>
                  Proceed to Cart
                </button>
              </div>
            </div>
          `;

          const close = () => {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('overflow-hidden', 'event-add-ons-modal-open');
            const placeholder = modal._placeholder;
            const originalParent = modal._originalParent;
            const originalNextSibling = modal._originalNextSibling;
            const movedNode = modal._movedNode;
            if (placeholder && originalParent && movedNode) {
              if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
                originalParent.insertBefore(movedNode, originalNextSibling);
              } else {
                originalParent.insertBefore(movedNode, placeholder);
              }
              placeholder.remove();
              modal._placeholder = null;
              modal._originalParent = null;
              modal._originalNextSibling = null;
              modal._movedNode = null;
            }
          };
          modal._close = close;

          modal.addEventListener('click', (e) => {
            if (e.target === modal) close();
          });
          modal.querySelector('[data-close]')?.addEventListener('click', close);
          modal.querySelector('[data-proceed-to-cart]')?.addEventListener('click', () => {
            window.location.href = window.routes?.cart_url || '/cart';
          });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && modal.classList.contains('is-open')) {
              close();
            }
          });
          document.body.appendChild(modal);
        }

        const mainTitleEl = modal.querySelector('[data-main-title]');
        const mainMetaEl = modal.querySelector('[data-main-meta]');
        const productTitle = mainEventContext?.name ||
          document.querySelector('.product__title h1')?.textContent?.trim()
          || document.querySelector('h1')?.textContent?.trim()
          || 'Your event';
        if (mainTitleEl) {
          mainTitleEl.textContent = productTitle;
        }

        if (mainMetaEl) {
          let variantLabel = mainEventContext?.details || '';
          let variantPriceText = '';
          const selectedVariantEl =
            document.querySelector('product-info variant-selects [data-selected-variant]')
            || document.querySelector('variant-selects [data-selected-variant]');

          if (!variantLabel && selectedVariantEl) {
            try {
              const selectedVariant = JSON.parse(selectedVariantEl.textContent.trim());
              variantLabel = (selectedVariant?.public_title || selectedVariant?.title || '').trim();
              const currencyCode = window.Shopify?.currency?.active || window.Shopify?.currency?.shop || 'USD';
              if (typeof selectedVariant?.price === 'number') {
                variantPriceText = new Intl.NumberFormat(undefined, {
                  style: 'currency',
                  currency: currencyCode,
                }).format(selectedVariant.price / 100);
              }
            } catch (e) {}
          }

          if (!variantPriceText && typeof mainEventContext?.price === 'number') {
            const currencyCode = window.Shopify?.currency?.active || window.Shopify?.currency?.shop || 'USD';
            variantPriceText = new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: currencyCode,
            }).format(mainEventContext.price / 100);
          }

          const metaParts = [variantLabel, variantPriceText].filter(Boolean);
          mainMetaEl.textContent = metaParts.join('  •  ');
          modal.dataset.mainEventDetails = variantLabel;
        }
        modal.dataset.mainEventName = productTitle;
        modal.dataset.mainEventKey = mainEventContext?.key || `${productTitle} - ${modal.dataset.mainEventDetails || ''}`;

        addOnsWrapper.querySelectorAll('product-form[data-add-on-product-id] form').forEach((form) => {
          const nameInput = form.querySelector('input[name="properties[Main Event Name]"]');
          const detailsInput = form.querySelector('input[name="properties[Main Event details]"]');
          const keyInput = form.querySelector('input[name="properties[_main_event_key]"]');
          if (nameInput) nameInput.value = modal.dataset.mainEventName;
          if (detailsInput) detailsInput.value = modal.dataset.mainEventDetails || '';
          if (keyInput) keyInput.value = modal.dataset.mainEventKey;
        });

        const body = modal.querySelector('[data-body]');
        if (!body) return;

        // Move the existing add-on section into modal (keeps ids/forms working, no duplicates).
        if (!modal._movedNode) {
          const placeholder = document.createElement('div');
          placeholder.setAttribute('data-event-add-ons-placeholder', 'true');
          const originalParent = addOnsWrapper.parentNode;
          const originalNextSibling = addOnsWrapper.nextSibling;
          if (!originalParent) return;
          originalParent.insertBefore(placeholder, addOnsWrapper);

          modal._placeholder = placeholder;
          modal._originalParent = originalParent;
          modal._originalNextSibling = originalNextSibling;
          modal._movedNode = addOnsWrapper;
        }

        body.innerHTML = '';
        body.appendChild(addOnsWrapper);

        // Ensure add-on ATC buttons are visible inside the popup.
        addOnsWrapper.querySelectorAll('.event-add-on-submit-btn, button[data-event-add-on-submit]').forEach((btn) => {
          btn.classList.remove('hidden');
          btn.setAttribute('aria-hidden', 'false');
        });
        this.initializeEventAddOnModalControls(addOnsWrapper);
        this.resetEventAddOnModalQuantities(addOnsWrapper);
        this.refreshEventAddOnsModalSummary(modal);

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden', 'event-add-ons-modal-open');
      }
    }
  );
}
